import { useInventoryManagementBasicFeatureGate } from './use-inventory-management-basic-feature-gate';
import { useProductCatalogFeatureGate } from './use-product-catalog-feature-gate';

/**
 * @returns {boolean}
 */
export const useIsProductsPageFeatureEnabled = () => {
  const { isFeatureEnabled: isProductCatalogFeatureEnabled } = useProductCatalogFeatureGate();
  const { isFeatureEnabled: isInventoryManagementBasicFeatureEnabled } = useInventoryManagementBasicFeatureGate();

  return isProductCatalogFeatureEnabled || isInventoryManagementBasicFeatureEnabled;
};
